export enum ConfirmStatus {
    back = 'confirmBack',
    backToDeliveryMethod = 'confirmBackToDeliveryMethod',
    backToPickASeat = 'confirmBackToPickASeat',
    backToReservedTicketConfirmation = 'confirmBackToReservedTicketConfirmation',
    closeModal = 'closeModal',
    toTicketSelectionFromInterstitial = 'confirmToTicketSelectionFromInterstitial',
    close = 'confirmClose',
    closeToDeliveryMethod = 'confirmCloseToDeliveryMethod',
    closeForLogin = 'confirmCloseForLogin',
    closeToInterstitial = 'confirmCloseToInterstitial',
    closeForPickASeat = 'confirmCloseForPickASeat',
    closeForReservedTicketConfirmation = 'confirmCloseForReservedTicketConfirmation',
    toCheckout = 'confirmToCheckout',
    toTicketSelection = 'toTicketSelection',
}
